<div style="display: flex; flex-direction: column; justify-content: center; align-items: center">
    <h1>{{translations.submitted}} <i class="fa fa-check-circle" style="color: green"></i></h1>
    <strong>{{translations['accounts.submitted.info']}}</strong>
</div>
